import React, { useState, useEffect, useContext }  from 'react'
import { Formik, Field, Form } from "formik";
import Modal from "react-modal";
import Loading from '@/shared/Loading';
import { fetchAPI } from '@/utility/NetworkUtils';
import { Stack, Button } from "@mui/material";
import { renderDateField, renderTextField } from '@/shared/FormUtils';
import { renderButton, renderCancelButton } from '@/shared/FormUtils'
import { DateTime } from 'luxon';
import EventAddressForm from './modal/EventAddressForm';
import DistributionLocations from './modal/DistributionLocations';
import EventUsersForm from './modal/EventUsersForm';
const EventModalRevised = ({
  id = null,
  open = false,
  onClose = () => {},
}) => {
  const [ event, setEvent ] = useState(null)
  const [ loading, setLoading ] = useState(true)
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const [ error, setError ] = useState(null)
  useEffect(()=> {
    if(open) {
      setIsSubmitting(false)
      loadEvent()
    }
  },[open, id])

  const loadEvent = async () => {
    setLoading(true)
    fetchAPI(id ? `/webapi/events/${id}` : `/webapi/events/new`, (json)=> {
      if (!json.error) {
        setEvent(json.event)
        setLoading(false)
      } else {
        setError(json.error)
        alert(json.error)
        onClose()
      }
    })
  }

  const getInitialValues = () => {
    let newEvent = {}
    if(event) {
      newEvent = {
        name: event.name,
        start_date: event.start_date,
        end_date: event.end_date,
        buffer_start_date: event.buffer_start_date,
        buffer_end_date: event.buffer_end_date,
        job_number: event.job_number,
      }
    } else {
      newEvent = {
        name: null,
        start_date: null,
        end_date: null,
        buffer_start_date: null,
        buffer_end_date: null,
        job_number: null,
      }
    }

    return {
      event: newEvent,
      event_locations: event ? (event.event_locations||[]) : [],
      user_ids: event ? (event.users||[]).map(x=>x.id) : [],
      shipping_address_ids: event ? (event.shipping_addresses||[]).map(x=>x.id) : []
    }
  }

  const submitForm = (values, formikProps) => {
    setIsSubmitting(true)
    setError(null)
    fetchAPI(`/webapi/events/${event.id}`, (json)=> {
      if (!json.error) {
        onClose()
      } else {
        setError(json.error)
      }
      setIsSubmitting(false)
    }, {
      method: "PATCH",
      body: {
        event: values.event,
        shipping_address_ids: values.shipping_address_ids,
        user_ids: values.user_ids
      }
    })
  }

  const renderFormInner = (formikProps) => {
    const { values: { event } } = formikProps;
    return (
      <Stack direction="column" spacing={2}>
        <div class="text-emerald-900 text-4xl font-medium font-['Roboto'] pb-4 font-weight-[400]">
          Event Info
        </div>
        {renderTextField( "Event Name", "event[name]", {})}
        {renderTextField("Job Number", "event[job_number]", {})}
        <Stack direction="row" spacing={2}>
          {renderDateField("Start Date", "event[start_date]",[], {
            fieldProperties: {
              afterChange: (value1, formatted) => {
                if(event.end_date < event.start_date) {
                  formikProps.setFieldValue("event[end_date]", formatted)
                }
                formikProps.setFieldValue("event[buffer_start_date]", DateTime.fromISO(formatted).minus({weeks: 2}).toISODate())
              }
            }
 
          })}
          {renderDateField("End Date", "event[end_date]", [],{
            fieldProperties:{
              minDate: event.start_date ? DateTime.fromISO(event.start_date) : null,
              afterChange: (value1, formatted) => {

                formikProps.setFieldValue("event[buffer_end_date]", DateTime.fromISO(formatted).plus({weeks: 2}).toISODate())
              }
            }
          })}
        </Stack>
        <Stack direction="row" spacing={2}>
          {renderDateField("Buffer Start Date", "event[buffer_start_date]",[], {
            fieldProperties:{
              maxDate: event.start_date ? DateTime.fromISO(event.start_date) : null 
            }
          })}
          {renderDateField("Buffer End Date", "event[buffer_end_date]",[], {
            fieldProperties:{
               minDate: event.end_date ? DateTime.fromISO(event.end_date) : null
            }
           
          })}
        </Stack>
        {areBufferDatesErroring(formikProps) && (
          <div className="text-red-500">
            Buffer dates should never be less than 5 days from event start and end dates. 
          </div>
        )}
       
      </Stack>
    )
  }

  const areBufferDatesErroring = (formikProps) => {
    const { values: { event } } = formikProps;
    if(
      event.buffer_start_date &&
      event.start_date &&
      DateTime.fromISO(event.buffer_start_date) > DateTime.fromISO(event.start_date).minus({days: 5})
    ) {
      return true
    }
    if(
      event.buffer_end_date &&
      event.end_date &&
      DateTime.fromISO(event.buffer_end_date) < DateTime.fromISO(event.end_date).plus({days: 5})
    ) {
      return true
    }
    return false
  }

  const renderButtons = (formikProps) => {
    return (
      <>
      {error && <div className="text-red-500">{error}</div>}
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        
        {renderButton("Save", formikProps.handleSubmit, {color:"green", disabled: isSubmitting})}
        {renderCancelButton("Cancel", onClose)}
      </Stack>
      </>
    )
  }


  const renderForm = () => {
    return (
      <Formik
        initialValues={getInitialValues()}
        onSubmit={submitForm}
        enableReinitialize
      >
        {(formikProps) => {
          return (
            <>
            {renderFormInner(formikProps)}
            {renderTabs()}
            <div className="mt-4">
              {renderTabComponent(formikProps)}
            </div>
            {renderButtons(formikProps)}
            </>
          )
        }}
      </Formik>
    )
  }

  const tabs = [
    {label:"Shipping Addresses", value:"shipping_addresses", component: (formikProps, event) => <EventAddressForm event={event} formikProps={formikProps} />},
    {label: "Distribution Locations", value:"reduce_inventory", component: (formikProps, event) => <DistributionLocations event={event} formikProps={formikProps} />},
    {label: "Users", value:"delete_item", component: (formikProps, event) => <EventUsersForm event={event} formikProps={formikProps} />},
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].value)
  const renderTabs = () => {
    return(
      <div className=" item-inventory-modal-tabs">
        {tabs.map(tab => (
          <div className={`item-inventory-modal-tab ${activeTab == tab.value ? "item-inventory-modal-tab-active" : "" }`} key={tab.value} onClick={()=>{
            setActiveTab(tab.value)
          }}>
            {tab.label}
          </div>
        ))}
      </div>
    );
  }

  const renderTabComponent = (formikProps) => {
    const tab = tabs.find(tab => tab.value == activeTab)
    if(tab) {
      return tab.component(formikProps, event)
    }
    return <> </>
  }


  return (
    <Modal
      className="react-modal add-attachment-modal add-form-modal w-[700px]"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={onClose}
      contentLabel="Add An Attachment"
    >
      {loading ? <Loading /> : renderForm()}
    </Modal>
  )
}

export default EventModalRevised